// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"AgeGroup_switchContainer__Mrg1O","switch":"AgeGroup_switch__FxEMe","switchimage":"AgeGroup_switchimage__2ES0u","switchActive":"AgeGroup_switchActive__2bPQd"};